import { useLocales } from '@shared/locales'
import { DatePicker, Form, Input, message, Modal, Select } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'

import { ActionsType } from './types'

export const EditContract = ({
  contract,
  onSuccess,
  ...props
}: ActionsType) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      // Demo: Simulate API call
      setTimeout(() => {
        setLoading(false)
        message.success(
          t('success.success_data_save') || 'Contract updated successfully'
        )
        onSuccess?.()
        props.onCancel?.()
      }, 500)
    } catch (error) {
      // Form validation failed
    }
  }

  return (
    <Modal
      width={600}
      maskClosable={false}
      title={t('contracts.edit_contract') || 'Edit Contract'}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      onOk={handleOk}
      confirmLoading={loading}
      {...props}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          title: contract?.title,
          status: contract?.status,
          deadline_at: contract?.deadline_at
            ? dayjs(contract.deadline_at)
            : undefined
        }}
      >
        <Form.Item
          name="title"
          label={t('generic.name') || 'Title'}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('generic.name') || 'Contract title'} />
        </Form.Item>
        <Form.Item name="status" label={t('contracts.status') || 'Status'}>
          <Select
            placeholder={t('main.select') || 'Select status'}
            options={[
              { value: 'draft', label: t('contracts.status_draft') || 'Draft' },
              {
                value: 'pending',
                label: t('contracts.status_pending') || 'Pending'
              },
              {
                value: 'signed',
                label: t('contracts.status_signed') || 'Signed'
              },
              {
                value: 'expired',
                label: t('contracts.status_expired') || 'Expired'
              },
              {
                value: 'cancelled',
                label: t('contracts.status_cancelled') || 'Cancelled'
              }
            ]}
          />
        </Form.Item>
        <Form.Item
          name="deadline_at"
          label={t('contracts.deadline') || 'Deadline'}
        >
          <DatePicker
            style={{ width: '100%' }}
            placeholder={t('contracts.deadline') || 'Select deadline'}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
